import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { CompanyRankingComponent } from './company-ranking.component';
var ɵ0 = { title: 'COMPANY_RANKING.TITLE' };
var routes = [
    {
        path: 'relatorios/classificacao-empresas',
        component: CompanyRankingComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var CompanyRankingModule = /** @class */ (function () {
    function CompanyRankingModule() {
    }
    return CompanyRankingModule;
}());
export { CompanyRankingModule };
export { ɵ0 };
